import React from "react";
import { Modal } from "react-bootstrap";
import "../styles/util.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopesBulk } from '@fortawesome/free-solid-svg-icons';


function ViewModal({ showModalSop,setShowModalSop }) {
  const handleClose = () => setShowModalSop(false);

  return (
    <Modal
      show={showModalSop}
      onHide={handleClose}
      animation={false}
      size="lg"
      centered
      scrollable
    >
      <Modal.Header closeButton className="title-modal txt-bold ">
        <FontAwesomeIcon icon={faEnvelopesBulk} className="font-awesome-icon txt-blue" aria-hidden="true" />
        <label> Soporte</label> 
      </Modal.Header>
      <Modal.Body className="mt-0">        
      <p className="txt-justify ml-3  mr-3">
          Para realizar consultas o reclamos al Comité de Administración de los
          respectivos sistemas, envíenos un mail indicando su Nro. de CUIT y
          Razón Social a:
          <br />
          <label className="txt-bold">SIRCREB: </label>{" "}
          <a href="mailto:sircreb@comisionarbitral.gob.ar">
            sircreb@comisionarbitral.gob.ar
          </a>
          <br />
          <label className="txt-bold ">SIRCUPA: </label>{" "}
          <a href="mailto:sircupa@comisionarbitral.gob.ar">
            sircupa@comisionarbitral.gob.ar
          </a>
          <br />
          <label className="txt-bold">SIRTAC: </label>{" "}
          <a href="mailto:sirtac@comisionarbitral.gob.ar">
            sirtac@comisionarbitral.gob.ar
          </a>
        </p>     
        <p className="txt-justify  mt-3 ml-3 mr-3">
          Puede obtener mayor información sobre ambos sistemas en los
          respectivos sitios web:
          <br />
          <label className="txt-bold ">SIRCREB: </label> {" "}         

          <a
            href="https://www.ca.gob.ar/sistemas/sircreb"
            target="_blank"
            rel="noreferrer"
          >
            https://www.ca.gob.ar/sistemas/sircreb
          </a>
          <br />
          <label className="txt-bold ">SIRCUPA: </label>{" "}
          <a
            href="https://www.ca.gob.ar/sistemas/sircupa"
            target="_blank"
            rel="noreferrer"
          >
            https://www.ca.gob.ar/sistemas/sircupa
          </a>
          <br />
          <label className="txt-bold ">SIRTAC: </label>{" "}
          <a
            href="https://www.ca.gob.ar/sistemas/sirtac"
            target="_blank"
            rel="noreferrer"
          >
            https://www.ca.gob.ar/sistemas/sirtac
          </a>
        </p>
      </Modal.Body>
    </Modal>
  );
}

export default ViewModal;
